import React from 'react';
import { flowRight as compose } from 'lodash';
import { connect } from 'react-redux';
import moment from 'moment';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import { Table, ButtonToolbar, Button, FormControl } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { FormattedMessage, injectIntl } from 'react-intl';
import Loader from '../../Common/Loader/Loader';
import Link from '../../Link/Link';
import CustomPagination from '../../CustomPagination/CustomPagination';
import CurrencyConverter from '../../CurrencyConverter/CurrencyConverter';

import { deleteUser } from '../../../actions/siteadmin/Users/deleteUser';
import getAllUsers from './getAllUsers.graphql'
import adjustWalletMutation from './adjustWallet.graphql'
import cashOutWalletMutation from './cashOutWallet.graphql'
import { showToaster } from '../../../helpers/toastrMessgaes/showToaster';
import { editUser } from '../../../actions/siteadmin/Users/editUser';
import debounce from '../../../helpers/debounce'
import messages from '../../../locale/messages';

import TrashIcon from '../../../../public/Icons/deleteIcon.svg';
import EditIcon from '../../../../public/Icons/editIcon.svg';
import ExportImage from '../../../../public/Icons/export.png';

import s from './UserList.css';
import bt from '../../../components/commonStyle.css';

class UsersList extends React.Component {
  static propTypes = {
    userDetails: PropTypes.object,
    deleteUser: PropTypes.any
  };
  constructor(props) {
    super(props)
    this.state = {
      currentPage: 1,
      searchList: '',
      adjustingId: null,
      cashingOutId: null
    }
    this.paginationData = this.paginationData.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleKeywordSearch = debounce(this.handleKeywordSearch.bind(this), 250);
    this.handleUserStatusChange = this.handleUserStatusChange.bind(this);
    this.handleBanStatusChange = this.handleBanStatusChange.bind(this);
    this.handleAdjustWallet = this.handleAdjustWallet.bind(this);
    this.handleCashOutWallet = this.handleCashOutWallet.bind(this);
  }
  handleKeywordSearch(searchList) {
    const { userDetails: { refetch } } = this.props
    let variables = {
      currentPage: 1,
      searchList
    }
    this.setState(variables)
    refetch(variables)
  }
  async handleDelete(profileId, currentPage, userType) {
    const { deleteUser, userDetails: { refetch } } = this.props;
    let variables = { currentPage }
    await deleteUser(profileId, currentPage, userType);
    refetch(variables)
  }
  async handleUserStatusChange(e, id, email, phoneDialCode, phoneNumber, isBan, phoneCountryCode, currentPage) {
    const { editUser, userDetails: { refetch } } = this.props;
    let data = {};
    data = {
      id: id,
      email: email,
      phoneDialCode: phoneDialCode,
      phoneNumber: phoneNumber,
      userStatus: e.target.value,
      isBan: isBan,
      phoneCountryCode: phoneCountryCode
    }
    let variables = { currentPage }
    await editUser(data);
    refetch(variables);
  }
  async handleBanStatusChange(e, id, email, phoneDialCode, phoneNumber, userStatus, phoneCountryCode, currentPage) {
    const { editUser, userDetails: { refetch } } = this.props;
    let data = {};
    data = {
      id: id,
      email: email,
      phoneDialCode: phoneDialCode,
      phoneNumber: phoneNumber,
      userStatus: userStatus,
      isBan: e.target.value,
      phoneCountryCode: phoneCountryCode
    }
    let variables = { currentPage }
    await editUser(data);
    refetch(variables);
  }
  paginationData(currentPage) {
    const { userDetails: { refetch } } = this.props;
    let variables = { currentPage };
    this.setState({ currentPage });
    refetch(variables);
  }
  /*
   * Penyesuaian saldo manual oleh admin.
   *
   * Selama app provider belum punya tombol isi ulang, ini satu-satunya cara
   * saldo bisa bertambah — dan saldo itulah yang menentukan apakah provider
   * masih menerima job cash. Nominal negatif diizinkan untuk mengoreksi salah
   * input; server yang menjaga jejaknya lewat ledger dan audit log.
   */
  async handleAdjustWallet(userId, currentBalance) {
    const raw = window.prompt(
      `Adjust wallet balance.\nCurrent: ${currentBalance || 0}\n\nEnter amount (negative to deduct):`
    );
    if (raw === null) return;

    const amount = Number(raw);
    if (!Number.isFinite(amount) || amount === 0) {
      showToaster({ messageId: 'errorMessage', requestContent: { content: 'Enter a non-zero number.' }, toasterType: 'error' });
      return;
    }

    const reason = window.prompt('Reason for this adjustment (required):');
    if (reason === null) return;
    if (String(reason).trim().length < 3) {
      showToaster({ messageId: 'errorMessage', requestContent: { content: 'A reason is required.' }, toasterType: 'error' });
      return;
    }

    this.setState({ adjustingId: userId });
    try {
      const { adjustWalletMutation, userDetails: { refetch } } = this.props;
      const { data } = await adjustWalletMutation({ variables: { userId, amount, reason } });
      if (data && data.adjustWallet && data.adjustWallet.status === 200) {
        showToaster({ messageId: 'walletAdjustSuccess', toasterType: 'success' });
        await refetch({ currentPage: this.state.currentPage });
      } else {
        showToaster({
          messageId: 'errorMessage',
          requestContent: { content: data && data.adjustWallet && data.adjustWallet.errorMessage },
          toasterType: 'error'
        });
      }
    } catch (error) {
      showToaster({ messageId: 'errorMessage', requestContent: { content: error.message }, toasterType: 'error' });
    }
    this.setState({ adjustingId: null });
  }

  /*
   * Mencairkan saldo wallet pelanggan kembali ke kartunya.
   *
   * BEDA DARI "Adjust" di sebelahnya, dan bedanya penting: Adjust cuma mengubah
   * angka saldo, tidak ada uang yang berpindah. Cash out benar-benar
   * mengembalikan uangnya lewat Stripe, ke kartu yang dulu dipakai mengisi
   * saldo. Admin tidak bisa mengarahkannya ke rekening lain — Stripe selalu
   * mengembalikan ke sumber aslinya.
   *
   * Hasilnya sengaja dilaporkan apa adanya: bagian yang tidak berasal dari
   * top-up kartu, atau yang top-upnya sudah lewat batas waktu refund Stripe,
   * TIDAK bisa dicairkan otomatis dan muncul sebagai nominal yang harus
   * ditransfer manual. Menyembunyikannya berarti saldo berkurang tanpa uang
   * yang benar-benar sampai.
   */
  async handleCashOutWallet(userId, currentBalance) {
    const balance = Number(currentBalance || 0);
    if (balance <= 0) {
      showToaster({ messageId: 'errorMessage', requestContent: { content: 'This user has no wallet balance.' }, toasterType: 'error' });
      return;
    }

    const raw = window.prompt(
      `Cash out wallet to the customer's card.\nBalance: ${balance}\n\n` +
      `Amount to refund (leave blank for the full balance):`
    );
    if (raw === null) return;

    let amount = null;
    if (String(raw).trim() !== '') {
      amount = Number(raw);
      if (!Number.isFinite(amount) || amount <= 0) {
        showToaster({ messageId: 'errorMessage', requestContent: { content: 'Enter a positive number.' }, toasterType: 'error' });
        return;
      }
      if (amount > balance) {
        showToaster({ messageId: 'errorMessage', requestContent: { content: 'Amount is larger than the balance.' }, toasterType: 'error' });
        return;
      }
    }

    const reason = window.prompt('Reason for this cash out (required):');
    if (reason === null) return;
    if (String(reason).trim().length < 3) {
      showToaster({ messageId: 'errorMessage', requestContent: { content: 'A reason is required.' }, toasterType: 'error' });
      return;
    }

    this.setState({ cashingOutId: userId });
    try {
      const { cashOutWalletMutation, userDetails: { refetch } } = this.props;
      const { data } = await cashOutWalletMutation({ variables: { userId, amount, reason } });
      const res = data && data.cashOutWallet;
      if (res && res.status === 200) {
        const manual = Number(res.manualAmount || 0);
        showToaster({
          messageId: 'errorMessage',
          requestContent: {
            content: manual > 0
              ? `Refunded ${res.refundedAmount} ${res.currency}. ${manual} ${res.currency} could not be refunded automatically — transfer it manually.`
              : `Refunded ${res.refundedAmount} ${res.currency} to the customer's card.`
          },
          toasterType: manual > 0 ? 'warning' : 'success'
        });
        await refetch({ currentPage: this.state.currentPage });
      } else {
        showToaster({
          messageId: 'errorMessage',
          requestContent: { content: res && res.errorMessage },
          toasterType: 'error'
        });
      }
    } catch (error) {
      showToaster({ messageId: 'errorMessage', requestContent: { content: error.message }, toasterType: 'error' });
    }
    this.setState({ cashingOutId: null });
  }

  render() {
    const { userDetails, userDetails: { getAllUsers }, loading } = this.props;
    const { currentPage, searchList } = this.state;
    const { formatMessage } = this.props.intl;
    return (
      <div className={cx(s.widthInner, 'whiteDropdown')}>
        <div className={s.exportDisplay}>
          <div>
            <div className={s.searchInput}>
              <FormControl type='text' placeholder={formatMessage(messages.searchOnly)} onChange={(e) => this.handleKeywordSearch(e.target && e.target.value)} className={bt.formControlInput} />
            </div>
          </div>

          <div className={cx(s.exportTextSection, 'textAlignLeftRTL', 'textAlignRightMbRTL')}>
            {
              userDetails && userDetails.getAllUsers && userDetails.getAllUsers.results && userDetails.getAllUsers.results.length > 0 && <a
                href={`/export-admin-data?type=users&keyword=${searchList ? searchList : ''}`}
                className={cx('pull-right', s.exportText)}>
                <span className={cx(s.vtrMiddle, s.exportText, 'exportTextRTL', 'textWhite')}><FormattedMessage {...messages.exportDataIntoCSV} /></span>
                <span className={cx(s.vtrTextBottom, 'svgImg')}>
                  <img src={ExportImage} className={s.exportImg} />
                </span>
              </a>
            }
          </div>
        </div>
        {
          loading && <div>
            <Loader type="circle" />
          </div>
        }
        {!loading &&
          <div className={cx(s.tableCss, 'tableCss', 'tableSticky', 'newAdminResponsiveTable', 'NewResponsiveTable')}>
            <Table className="table">
              <thead>
                <tr>
                  <th scope="col"><FormattedMessage {...messages.id} /></th>
                  <th scope="col"><FormattedMessage {...messages.firstName} /></th>
                  <th scope="col"><FormattedMessage {...messages.lastName} /></th>
                  <th scope="col"><FormattedMessage {...messages.email} /></th>
                  <th scope="col"><FormattedMessage {...messages.walletBalance} /></th>
                  <th scope="col">Adjust</th>
                  <th scope="col">Cash out</th>
                  <th scope="col"><FormattedMessage {...messages.country} /></th>
                  <th scope="col"><FormattedMessage {...messages.phoneNumber} /></th>
                  <th scope="col"><FormattedMessage {...messages.createdAt} /></th>
                  <th scope="col"><FormattedMessage {...messages.banStatus} /></th>
                  <th scope="col"><FormattedMessage {...messages.action} /></th>
                  <th scope="col"><FormattedMessage {...messages.deleteAction} /></th>
                </tr>
              </thead>
              <tbody>
                {
                  userDetails && userDetails.getAllUsers && userDetails.getAllUsers.results && userDetails.getAllUsers.results.length > 0 && userDetails.getAllUsers.results.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td data-label={formatMessage(messages.id)}>{item && item.profile && item.profile.profileId}</td>
                        <td data-label={formatMessage(messages.firstName)}>{item && item.profile && item.profile.firstName}</td>
                        <td data-label={formatMessage(messages.lastName)}> {item && item.profile && item.profile.lastName}</td>
                        <td data-label={formatMessage(messages.email)}>{item.email}</td>
                        <td data-label={formatMessage(messages.walletBalance)}>{item && item.profile && <CurrencyConverter from={item.profile.preferredCurrency} amount={item.profile.walletBalance} />}</td>
                        <td data-label="Adjust">
                          <Button
                            className={cx(bt.btnPrimaryBorder, bt.btnSmall)}
                            disabled={this.state.adjustingId === item.id}
                            onClick={() => this.handleAdjustWallet(item.id, item.profile && item.profile.walletBalance)}>
                            {this.state.adjustingId === item.id ? '...' : 'Adjust'}
                          </Button>
                        </td>
                        <td data-label="Cash out">
                          <Button
                            className={cx(bt.btnPrimaryBorder, bt.btnSmall)}
                            disabled={this.state.cashingOutId === item.id
                              || !(item.profile && Number(item.profile.walletBalance) > 0)}
                            onClick={() => this.handleCashOutWallet(item.id, item.profile && item.profile.walletBalance)}>
                            {this.state.cashingOutId === item.id ? '...' : 'Cash out'}
                          </Button>
                        </td>
                        <td data-label={formatMessage(messages.country)}>{item && item.profile && item.profile.country}</td>
                        <td data-label={formatMessage(messages.phoneNumber)}>{item && item.phoneDialCode}{item && item.phoneNumber}</td>
                        <td data-label={formatMessage(messages.createdAt)}>{moment(item.createdAt).format('DD-MM-YYYY HH:mm:ss')}</td>
                        <td data-label={formatMessage(messages.banStatus)}>
                          <select name="isBan" className={bt.selectInput}
                            onChange={(e) => this.handleBanStatusChange(e, item.id, item.email, item.phoneDialCode, item.phoneNumber, item.userStatus, item.phoneCountryCode, currentPage)} value={item.isBan}>
                            <option value="0">{formatMessage(messages.permit)}</option>
                            <option value="1">{formatMessage(messages.ban)}</option>
                          </select>
                        </td>
                        <td data-label={formatMessage(messages.action)}>
                          <Link to={'/siteadmin/users/' + item.profile.profileId} className={cx(s.noLink, 'darkLink', s.displayFlex)}>
                            <span className={'svgImg'}><img src={EditIcon} className={cx(s.editIcon, 'editIconRTL')} /></span>
                            <span className={cx(s.vtrMiddle)}>
                              <FormattedMessage {...messages.editAction} />
                            </span>
                          </Link>
                        </td >
                        <td data-label={formatMessage(messages.deleteAction)}>

                          <Button onClick={() => this.handleDelete(item.profile.profileId, currentPage, 1)} className={cx(s.iconBtn, 'svgImg', 'darkLink')}>
                            <img src={TrashIcon} className={cx(s.editIcon, 'editIconRTL')} />
                            <span className={s.vtrMiddle}>
                              <FormattedMessage {...messages.deleteAction} />
                            </span>
                          </Button>

                        </td>
                      </tr>
                    )
                  })
                }
                {
                  (!loading && (userDetails && userDetails.getAllUsers && userDetails.getAllUsers.results.length == 0)) && (
                    <tr>
                      <td colspan="12" className={s.noRecords}><FormattedMessage {...messages.noResult} /></td>
                    </tr>
                  )
                }
              </tbody>
            </Table>
          </div>
        }
        {
          userDetails && userDetails.getAllUsers && userDetails.getAllUsers.results && userDetails.getAllUsers.results.length > 0
          && <div className={cx(bt.space5, bt.spaceTop5)}>
            <CustomPagination
              total={userDetails.getAllUsers.count}
              currentPage={currentPage}
              defaultCurrent={1}
              defaultPageSize={10}
              change={this.paginationData}
              paginationLabel={formatMessage(messages.users)}
            />
          </div>
        }
      </div>
    );
  }
}
const mapState = (state) => ({
  loading: state.intl.loading
});
const mapDispatch = {
  deleteUser,
  editUser
};
export default compose(injectIntl,
  withStyles(s, bt),
  graphql(getAllUsers, {
    name: 'userDetails',
    options: {
      variables: {
        currentPage: 1,
        searchList: '',
        userType: 1
      },
      ssr: true,
      fetchPolicy: 'network-only'
    }
  }),
  graphql(adjustWalletMutation, { name: 'adjustWalletMutation' }),
  graphql(cashOutWalletMutation, { name: 'cashOutWalletMutation' }),
  connect(mapState, mapDispatch)
)(UsersList);
